import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Fixed } from 'layouts';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Switch,
  FormControlLabel,
  Tooltip,
  Radio,
  Checkbox,
  ListItemText,
  FormLabel,
  FormGroup,
  Card,
  Typography,
  TextField,
  OutlinedInput,
  Chip,
  Modal,
  InputAdornment,
  CircularProgress,
  Icon,
  Divider,
  DialogContentText,
  RadioGroup,
  Grid,
  TableFooter,
  Fab,
  Menu,
  Drawer,
} from '@mui/material';
import moment from 'moment';
import {
  Add,
  ArrowBack,
  Assignment,
  ChevronRight,
  Close,
  CopyAll,
  Delete,
  Edit,
  ExitToApp,
  Group,
  Home,
  Link,
  Lock,
  Mic,
  Notes,
  Redo,
  Replay,
  Send,
  StopCircle,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import getAllPrompts from 'redux/actions/Common/getAllPrompts';
import RichTextEditor from 'components/RichTextEditor';
import updatePlaybookForUser from 'redux/actions/Common/updatePlaybookForUser';
import updatePrompt from 'redux/actions/Common/updatePrompt';
import createNewPrompt from 'redux/actions/Common/createNewPrompt';
import deletePrompt from 'redux/actions/Common/deletePrompt';
import { capitalizeText } from 'utils';
import makePromptAsDefaultPrompt from 'redux/actions/Common/makePromptAsDefaultPrompt';
import getPromptPreview from 'redux/actions/Common/getPromptPreview';
import getBotsByPromptId from 'redux/actions/Common/getBotsByPromptId';
import updateBotsPrompt from 'redux/actions/Common/updateBotsPrompt';
import getJSONProperties from 'redux/actions/Common/getJSONProperties';
import { useParams } from 'react-router-dom';
import getPromptTypes from 'redux/actions/Common/getPromptTypes';
import { use } from 'react';
import { aiModels, modelMapping } from 'data';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const promptTypeMapping = {
  conversation: 'Conversation',
  call_analysis_method: 'Methodologies',
  call_analysis_method_spin: 'SPIN Method',
  call_analysis_method_star: 'STAR Method',
  call_analysis_method_meddpic: 'MEDDPIC Method',
  call_analysis_method_spiced: 'SPICED Method',
  call_analysis_method_bant: 'BANT Method',
  call_analysis_method_challenger: 'CHALLENGER Method',
  call_analysis_feedback: 'Playbook',
  call_analysis_feedback_for_otpc: 'Playbook feedback for otpc',
  call_summary: 'Call Summary',
  io_bond_call_summary: 'Call Summary Inbound/Outbound',
  playbook_prompt: 'Playbook generation prompt',
  playbook_analysis_for_inbound_call: 'Playbook inbound',
  playbook_analysis_for_outbound_call: 'Playbook outbound',
  numeric_discussion_prompt: 'Numeric Discussion',
  ask_ai: 'ASK AI',
  context_query_prompt: 'Context Query',
  custom_method_prompt: 'Custom Method',
  preset_question_prompt: 'Preset Questions',
  hubspot_property_prompt: 'Hubspot Property Prompt',
  content_scoring_prompt: 'Content Scoring',
  content_scoring_prompt_inbound: 'Content Scoring Inbound',
  content_scoring_prompt_outbound: 'Content Scoring Outbound',
  custom_playbook_prompt: 'Custom Playbook Prompt',
  speaker_detection_prompt: 'Speaker Detection Prompt',
  model_fine_tuning_text: 'Model Fine Tuning Text',
  model_fine_tuning_text_and_question: 'Model Fine Tuning Text and Question',
  model_fine_tuning_text_and_question_for_video_based_sheet:
    'Model Fine Tuning Text and Question for Video Based Sheet',
  deal_summary: 'Deal Summary',
  value_proposition: 'Value Proposition',
  company_objectives: 'Company Objectives',
  team_objectives: 'Team Objectives',
  priorities: 'Priorities',
  current_state: 'Current State',
  blockers: 'Blockers',
  negative_consequence: 'Negative Consequence',
  after_state: 'After State',
  positive_outcome: 'Positive Outcome',
  generate_question: 'Generate Question',
  arrange_question: 'Arrange Question',
  followup_question: 'Followup Question',
  followup_question_sub_topic_wise: 'Followup Question Sub Topic Wise',
  generate_question_sub_topic_wise: 'Generate Question Sub Topic Wise',
  arrange_question_sub_topic_wise: 'Arrange Question Sub Topic Wise',
  discovery_tree_deal_interaction: 'Discovery Tree Deal Interaction',
  discovery_tree_deal_interaction_buyers_reference:
    'Discovery Tree Deal Interaction Buyers Reference',
  discovery_tree_deal_interaction_summary:
    'Discovery Tree Deal Interaction Summary',
  selling_style_specific_question_sub_topic_wise:
    'Selling Style Specific Question Sub Topic Wise',
  convert_single_question_to_selling_style:
    'Convert Single Question to Selling Style',
  selling_style_specific_question: 'Selling Style Specific Question',
  discovery_tree_deal_interaction_combined:
    'Discovery Tree Deal Interaction Combined',
  generate_objectives_for_risks: 'Generate Objectives for Risks',
  generate_question_for_risk: 'Generate Question for Risk',
  add_question_category_for_risk: 'Add Question Category for Risk',
  deals_expert_conversation: 'Deals Expert Conversation',
  discovery_tree_deal_interaction_summary_one_line:
    'Discovery Tree Deal Interaction Summary One Line',
  nba_risk_selection: 'Next Best Actions Risk Selection',
  nba_actions: 'Next Best Actions',
  risk_stage_association: 'Risk Stage Association',
  overall_deal_summary: 'Overall Deal Summary',
  deal_stage_mapping_prompt: 'Deal Stage Mapping Prompt',
  buyers_prop: 'Buyers Prop',
  stack_holder_topics: 'Stack Holder Topics of Interest',
  stack_holder_deep_research: 'Stack Holder Deep Research',
  reorder_designation_prompt: 'Reorder Designation Prompt',
  stack_holder_search_prompt: 'Stack Holder Search Prompt',
  company_info_prompt: 'Company Info Prompt',
  org_chart_prompt: 'Org Chart Prompt',
  transcript_prompt: 'Transcript Prompt',
  json_to_html_prompt: 'JSON to HTML Prompt',
  email_thread_to_email_list: 'Email Thread to Email List',
  nba_actions_inbound_email: 'NBA Actions Inbound Email',
  buyers_prop_for_meetings_and_call: 'Buyers Prop for Meetings and Call',
  nba_risk_selection_for_meeting_and_call:
    'NBA Risk Selection for Meeting and Call',
  nba_risk_mitigation: 'NBA Risk Mitigation',
  nba_actions_call_and_meeting: 'NBA Actions Call and Meeting',
  file_summary_and_title: 'File Summary and Title',
  document_outline: 'Document Outline',
  json_to_json_html_prompt: 'JSON to JSON HTML Prompt',
  interaction_highlight: 'Interaction Highlight',
  nba_actions_notes: 'NBA Actions Notes',
  calendar_meeting_agenda: 'Calendar Meeting Agenda',
  email_to_potential_deal: 'Email to Potential Deal',
  basic_deal_info: 'Basic Deal Info',
  meeting_prep: 'Meeting Prep',
  meeting_prep_hypothesis: 'Meeting Prep Hypothesis',
  fallback_risk_generation: 'Fallback Risk Generation',
  meeting_prep_hypothesis_combo: 'Meeting Prep Hypothesis Combo',
  meeting_prep_goals: 'Meeting Prep Goals',
  meeting_link_extraction_prompt: 'Meeting Link Extraction Prompt',
  email_response_recommendation: 'Email Response Recommendation',
  interaction_highlight_call_or_meeting:
    'Interaction Highlight Call or Meeting',
  interaction_highlight_email: 'Interaction Highlight Email',
  deal_highlights_update: 'Deal Highlight - Update',
  deal_highlights_generate: 'Deal Highlights - Generate',
  deal_highlights_filter_interaction_highlights:
    'Deal Highlights - Filter Interaction Highlights',
  expert_bot_conversation_planner: 'Expert Bot Conversation Planner',
  web_search_for_rag_context: 'Web Search for RAG Context',
  filter_interaction_highlights_for_deal_highlights:
    'Filter Interaction Highlights for Deal Highlights',
  generate_deal_highlights: 'Generate Deal Highlights',
  update_deal_highlights: 'Update Deal Highlights',
  test_llm_prompt: 'Test LLM Prompt',
  interaction_rag_content_synthesizer: 'Interaction RAG content Synthesizer',
  inbound_email_response_context_planner:
    'Inbound Email Response Context Planner',
  json_repair: 'JSON Repair',
  value_prop_to_designation: 'Value Prop to Designation',
  industry_research_prompt: 'Industry Research Prompt',
  meeting_prep_steps: 'Meeting Prep Steps',
};

const Prompts = () => {
  const theme = useTheme();
  const history = useHistory();
  const { version } = useParams();
  const dispatch = useDispatch();
  const { pathname, state } = useLocation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isXs = useMediaQuery(theme.breakpoints.only('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.only('sm'), {
    defaultMatches: true,
  });
  const {
    prompts,
    fetchingPagination,
    emptyList,
    fetching,
    lastTime,
  } = useSelector((state) => state.allPrompts);
  const [sections, setSections] = useState([]);

  const [selectedPrompt, setSelectedPrompt] = useState('');
  const [promptTitle, setPromptTitle] = useState('');
  const [promptSections, setPromptSections] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [placeholder, setPlaceholder] = useState({});
  const [responseType, setResponseType] = useState('string');

  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(null);
  const [promptType, setPromptType] = useState(
    version === 'v1' ? 'conversation' : 'model_fine_tuning_text_and_question',
  );

  const [showPromptPreview, setShowPromptPreview] = useState('');
  const [showPromptPreviewFor, setShowPromptPreviewFor] = useState('');
  const [
    showConfirmPromptUpdateDialog,
    setShowConfirmPromptUpdateDialog,
  ] = useState(null);

  const [botsByPromptId, setBotsByPromptId] = useState([]);

  const [jsonProperties, setJsonProperties] = useState([]);
  const [gettingJSONProperties, setGettingJSONProperties] = useState(false);

  const [promptCategories, setPromptCategories] = useState(null);
  const [promptTypes, setPromptTypes] = useState([]);
  const [models, setModels] = useState(aiModels);

  const [model, setModel] = useState('gpt-4.1-mini');
  const [useWebSearch, setUseWebSearch] = useState('false');

  const handleAddSectionClick = (event) => {
    if (anchorEl) setAnchorEl(null);
    else setAnchorEl(event.target);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleListScroll = (e, paginate) => {
    if (
      (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight &&
        // viewType === 'list' &&
        !fetching &&
        !fetchingPagination &&
        prompts &&
        prompts.length % 15 === 0 &&
        emptyList === false) ||
      paginate
    ) {
      dispatch(getAllPrompts(promptType, 15, lastTime, () => {}));
    }
  };

  useEffect(() => {
    if (
      (showConfirmPromptUpdateDialog || showConfirmDeleteDialog) &&
      promptType === 'conversation'
    ) {
      dispatch(
        getBotsByPromptId(
          showConfirmPromptUpdateDialog || showConfirmDeleteDialog,
          (data) => {
            console.log(data);
            setBotsByPromptId(data || []);
          },
        ),
      );
    }
  }, [showConfirmPromptUpdateDialog, showConfirmDeleteDialog]);

  useEffect(() => {
    if (selectedPrompt && selectedPrompt !== 'create') {
      setPromptSections(
        prompts?.find((pr) => pr?.id === selectedPrompt)?.promptSections,
      );
      setPromptTitle(prompts?.find((pr) => pr?.id === selectedPrompt)?.title);
      setResponseType(
        prompts?.find((pr) => pr?.id === selectedPrompt)?.responseType ||
          'string',
      );
      setJsonProperties(
        prompts?.find((pr) => pr?.id === selectedPrompt)?.jsonConfig
          ?.propertyConfigs || [],
      );
      setUseWebSearch(
        prompts?.find((pr) => pr?.id === selectedPrompt)?.useWebSearch
          ? 'true'
          : 'false',
      );
    } else {
      setPromptSections([]);
      setPromptTitle('');
      setJsonProperties([]);
    }
  }, [selectedPrompt]);

  useEffect(() => {
    dispatch(getAllPrompts(promptType, 15, null, () => {}));
    if (promptType === 'conversation') {
      setSections([
        'User_Information_Section',
        'AI_Anonymity',
        'Basic_Conversation_Instructions',
        'Personality_Description',
        'Company_Details',
        'Recent_Market_Changes_Information',
        'Availability_for_Meetings',
        'Objections',
        'Customer_Challenges',
        'Verbosity',
        'VERTICAL',
        'DESIGNATION',
        'COMPETITORS',
      ]);
    } else if (promptType === 'call_analysis_method') {
      setSections(['sales_call_analysis_method']);
    } else if (promptType === 'call_analysis_feedback') {
      setSections(['sales_call_feedback']);
    } else if (promptType === 'playbook_analysis_for_inbound_call') {
      setSections(['sales_call_feedback']);
    } else if (promptType === 'playbook_analysis_for_outbound_call') {
      setSections(['sales_call_feedback']);
    } else if (promptType === 'call_analysis_feedback_for_otpc') {
      setSections(['sales_call_feedback']);
    } else if (promptType === 'call_summary') {
      setSections(['sales_call_summary']);
    } else if (promptType === 'io_bond_call_summary') {
      setSections(['sales_call_summary']);
    } else if (promptType === 'numeric_discussion_prompt') {
      setSections(['numeric_discussion_section']);
    } else if (promptType === 'ask_ai') {
      setSections(['Basic_Conversation_Instructions']);
    } else if (
      promptType === 'call_analysis_method_spin' ||
      promptType === 'call_analysis_method_spiced' ||
      promptType === 'call_analysis_method_meddpic' ||
      promptType === 'call_analysis_method_bant' ||
      promptType === 'call_analysis_method_challenger' ||
      promptType === 'call_analysis_method_star'
    ) {
      setSections(['sales_call_analysis_method']);
    } else if (
      promptType === 'playbook_prompt' ||
      promptType === 'custom_playbook_prompt'
    ) {
      setSections([
        'playbook_basic_instruction',
        'playbook_product_list',
        'playbook_output_instruction',
      ]);
    } else if (promptType === 'context_query_prompt') {
      setSections(['context_query']);
    } else if (promptType === 'content_scoring_prompt') {
      setSections(['content_scoring_section']);
    } else if (promptType === 'content_scoring_prompt_inbound') {
      setSections(['content_scoring_section']);
    } else if (promptType === 'content_scoring_prompt_outbound') {
      setSections(['content_scoring_section']);
    } else if (promptType === 'preset_question_prompt') {
      setSections(['general instruction', 'ai anonymity', 'json instruction']);
    } else if (promptType === 'speaker_detection_prompt') {
      setSections(['speaker_detection_instruction']);
    } else if (promptType === 'hubspot_property_prompt') {
      setSections(['general instruction', 'json instruction']);
    } else if (promptType === 'model_fine_tuning_text_and_question') {
      setSections(['main_section', 'json instruction']);
    } else if (
      promptType === 'deal_summary' ||
      promptType === 'value_proposition' ||
      promptType === 'company_objectives' ||
      promptType === 'team_objectives' ||
      promptType === 'priorities' ||
      promptType === 'current_state' ||
      promptType === 'blockers' ||
      promptType === 'negative_consequence' ||
      promptType === 'after_state' ||
      promptType === 'positive_outcome' ||
      promptType === 'generate_question' ||
      promptType === 'arrange_question' ||
      promptType === 'followup_question' ||
      promptType === 'expert_bot_conversation_planner' ||
      promptType === 'web_search_for_rag_context' ||
      promptType === 'document_outline'
    ) {
      setSections(['main_section', 'json instruction']);
    } else {
      setSections([]);
    }
  }, [promptType, version]);

  useEffect(() => {
    if (
      Object.keys(promptCategories || {}) &&
      Object.keys(promptCategories || {}).length > 0
    ) {
      setPromptTypes(
        version === 'v1'
          ? promptCategories?.['QAI-V1']
          : promptCategories?.['QAI-V2'],
      );
    }
  }, [promptCategories, version]);

  useEffect(() => {
    if (selectedPrompt === 'create') {
      setModel('gpt-4o-mini');
    } else if (selectedPrompt) {
      setModel(prompts?.find((prompt) => prompt?.id === selectedPrompt)?.model);
    }
  }, [selectedPrompt]);

  useEffect(() => {}, [version]);

  useEffect(() => {
    dispatch(
      getPromptTypes(
        (promptTypes) => {
          setPromptCategories(promptTypes);
        },
        () => {},
      ),
    );
  }, []);

  console.log(version);

  return (
    <Fixed>
      <Box
        width={{ xs: '100vw', sm: '100vw', md: 'calc(100vw - 266px)' }}
        height={{
          xs: 'calc(100vh - 60px)',
          sm: 'calc(100vh - 70px)',
          md: 'calc(100vh - 80px)',
        }}
        sx={{
          overflow: 'auto',
        }}
        display={'flex'}
        flexDirection={{ xs: 'column', md: 'column' }}
        position={'relative'}
        gap={1}
      >
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', sm: 'column', md: 'column' }}
          p={2}
          position={'relative'}
        >
          {selectedPrompt ? (
            <Box>
              <Box p={1} display={'flex'} alignItems={'center'} gap={2}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBack />}
                  onClick={() => {
                    setSelectedPrompt('');
                  }}
                  color="primary"
                  size="small"
                >
                  Go Back
                </Button>
              </Box>
              <Box
                sx={{
                  maxWidth: 900,
                  margin: '0 auto',
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      // sx={{ marginBottom: 2 }}
                    >
                      <FormLabel id="demo-row-radio-buttons-group-label">
                        Prompt Type
                      </FormLabel>
                      <Select
                        // ref={promptSelectRef}
                        labelId="prompt-select-label"
                        // label="Select Prompt"
                        value={promptType || ''}
                        onChange={(e) => {
                          setPromptType(e.target.value);
                        }}
                      >
                        {promptTypes?.map((promptType) => (
                          <MenuItem value={promptType}>
                            {promptTypeMapping?.[promptType]}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      // sx={{ marginBottom: 2 }}
                    >
                      <FormLabel id="demo-row-radio-buttons-group-label">
                        Prompt Model
                      </FormLabel>
                      <Select
                        // ref={promptSelectRef}
                        labelId="prompt-select-label"
                        // label="Select Prompt"
                        value={model || ''}
                        onChange={(e) => {
                          setModel(e.target.value);
                        }}
                      >
                        {models?.map((model) => (
                          <MenuItem value={model}>
                            {modelMapping[model]}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {promptType === 'stack_holder_search_prompt' ||
                  promptType === 'stack_holder_deep_research' ||
                  promptType === 'company_info_prompt' ||
                  promptType === 'org_chart_prompt' ||
                  promptType === 'stack_holder_topics' ||
                  promptType === 'meeting_prep_hypothesis' ||
                  promptType === 'meeting_prep' ||
                  promptType === 'basic_deal_info' ? (
                    <Grid item xs={12}>
                      <FormControl
                        variant="outlined"
                        size="small"
                        // sx={{ marginBottom: 2 }}
                      >
                        <FormLabel id="demo-row-radio-buttons-group-label">
                          Use web search
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group1"
                          value={useWebSearch}
                          onChange={(e) => setUseWebSearch(e.target.value)}
                        >
                          <FormControlLabel
                            value={'true'}
                            control={<Radio />}
                            label={'Use Web Search'}
                          />
                          <FormControlLabel
                            value={'false'}
                            control={<Radio />}
                            label={'Do Not Use Web Search'}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  ) : null}
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color={'text.secondary'}>
                      Title
                    </Typography>
                    <TextField
                      autoFocus
                      placeholder="Title"
                      variant="outlined"
                      color="primary"
                      size="small"
                      name="title"
                      value={promptTitle}
                      onChange={(e) => setPromptTitle(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      variant="outlined"
                      size="small"
                      // sx={{ marginBottom: 2 }}
                    >
                      <FormLabel id="demo-row-radio-buttons-group-label">
                        Response Type
                      </FormLabel>
                      <Select
                        // ref={promptSelectRef}
                        labelId="prompt-select-label"
                        // label="Select Prompt"
                        value={responseType || ''}
                        onChange={(e) => {
                          setResponseType(e.target.value);
                        }}
                      >
                        <MenuItem value={'string'}>String</MenuItem>
                        <MenuItem value={'json'}>JSON</MenuItem>
                        <MenuItem value={'html'}>HTML</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {promptSections?.length === 0 ? (
                    <Grid item xs={12} textAlign={'right'}>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<Add />}
                        color="primary"
                        onClick={(e) => {
                          handleAddSectionClick(e);
                        }}
                      >
                        Add Section
                      </Button>
                      <Menu
                        id="add-section-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        disableScrollLock={true}
                        transformOrigin={{
                          horizontal: 'right',
                          vertical: 'top',
                        }}
                        anchorOrigin={{
                          horizontal: 'right',
                          vertical: 'bottom',
                        }}
                        style={{
                          marginTop: '15px',
                        }}
                      >
                        {sections.map((sc) => (
                          <Tooltip
                            key={sc}
                            title={
                              promptSections?.find((ps) => ps?.type === sc)
                                ? 'Section is already added'
                                : ''
                            }
                            arrow
                            placement="right"
                          >
                            <MenuItem
                              value={sc}
                              onClick={(e) => {
                                if (
                                  !promptSections?.find((ps) => ps?.type === sc)
                                ) {
                                  setPromptSections((prev) => {
                                    return [
                                      ...prev,
                                      {
                                        type: sc,
                                        text: '',
                                        placeHolders: {},
                                        optionalSection:
                                          sc === 'VERTICAL' ||
                                          sc === 'DESIGNATION' ||
                                          sc === 'COMPETITORS'
                                            ? true
                                            : false,
                                      },
                                    ];
                                  });
                                }
                                handleClose();
                              }}
                            >
                              <Typography
                                color={
                                  promptSections?.find((ps) => ps?.type === sc)
                                    ? 'text.secondary'
                                    : 'text.primary'
                                }
                              >
                                {sc}
                              </Typography>
                            </MenuItem>
                          </Tooltip>
                        ))}
                      </Menu>
                    </Grid>
                  ) : null}
                  {promptSections?.map((ps) => (
                    <>
                      <Grid item xs={12} textAlign={'right'}>
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={<Add />}
                          color="primary"
                          onClick={(e) => {
                            handleAddSectionClick(e);
                          }}
                        >
                          Add Section
                        </Button>
                        <Menu
                          id="add-section-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                          disableScrollLock={true}
                          transformOrigin={{
                            horizontal: 'right',
                            vertical: 'top',
                          }}
                          anchorOrigin={{
                            horizontal: 'right',
                            vertical: 'bottom',
                          }}
                          style={{
                            marginTop: '15px',
                          }}
                        >
                          {sections.map((sc) => (
                            <Tooltip
                              key={sc}
                              title={
                                promptSections?.find((ps) => ps?.type === sc)
                                  ? 'Section is already added'
                                  : ''
                              }
                              arrow
                              placement="right"
                            >
                              <MenuItem
                                value={sc}
                                onClick={(e) => {
                                  if (
                                    !promptSections?.find(
                                      (ps) => ps?.type === sc,
                                    )
                                  ) {
                                    setPromptSections((prev) => {
                                      return [
                                        ...prev,
                                        {
                                          type: sc,
                                          text: '',
                                          placeHolders: {},
                                          optionalSection:
                                            sc === 'VERTICAL' ||
                                            sc === 'DESIGNATION' ||
                                            sc === 'COMPETITORS'
                                              ? true
                                              : false,
                                        },
                                      ];
                                    });
                                  }
                                  handleClose();
                                }}
                              >
                                <Typography
                                  color={
                                    promptSections?.find(
                                      (ps) => ps?.type === sc,
                                    )
                                      ? 'text.secondary'
                                      : 'text.primary'
                                  }
                                >
                                  {sc}
                                </Typography>
                              </MenuItem>
                            </Tooltip>
                          ))}
                        </Menu>
                      </Grid>
                      <Grid item xs={12} key={ps?.type}>
                        <Box display={'flex'} flexDirection={'column'} gap={1}>
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            // justifyContent={'space-between'}
                            gap={1}
                          >
                            <Typography
                              variant="subtitle2"
                              color={'text.secondary'}
                            >
                              Placeholders
                            </Typography>
                          </Box>
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            // justifyContent={'space-between'}
                            gap={1}
                          >
                            <TextField
                              autoFocus
                              placeholder="placeholder"
                              variant="outlined"
                              color="primary"
                              size="small"
                              name="placeholder"
                              value={placeholder?.[ps?.type]}
                              onChange={(e) =>
                                setPlaceholder((prev) => {
                                  return {
                                    ...prev,
                                    [ps?.type]: e.target.value,
                                  };
                                })
                              }
                              // fullWidth
                            />
                            <Button
                              variant="text"
                              size="small"
                              startIcon={<Add />}
                              onClick={() => {
                                if (placeholder?.[ps?.type]?.trim()) {
                                  const updatedPlaceholdersArr = [
                                    ...Object.keys(ps?.placeHolders || {}),
                                    placeholder?.[ps?.type],
                                  ];
                                  const updatedPromptSections = [
                                    ...promptSections,
                                  ];
                                  setPromptSections((prev) => {
                                    const map = {};
                                    updatedPlaceholdersArr.map(
                                      (uph) => (map[uph] = ''),
                                    );
                                    // console.log(map);
                                    return updatedPromptSections?.map((ups) => {
                                      if (ups.type === ps.type) {
                                        return {
                                          ...ups,
                                          placeHolders: map,
                                        };
                                      } else {
                                        return ups;
                                      }
                                    });
                                  });
                                  setPlaceholder((prev) => {
                                    return {
                                      ...prev,
                                      [ps?.type]: '',
                                    };
                                  });
                                }
                              }}
                            >
                              Add placeholder
                            </Button>
                          </Box>
                          {ps?.placeHolders &&
                          Object.keys(ps?.placeHolders) &&
                          Array.isArray(Object.keys(ps?.placeHolders)) &&
                          Object.keys(ps?.placeHolders)?.length > 0 ? (
                            <Box
                              display={'flex'}
                              alignItems={'center'}
                              gap={1}
                              flexWrap={'wrap'}
                            >
                              {Object.keys(ps?.placeHolders)?.map(
                                (ph, index) => (
                                  <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    flexWrap={'wrap'}
                                  >
                                    <Chip
                                      key={ph}
                                      label={ph}
                                      size="medium"
                                      color="primary"
                                    />
                                    <Tooltip
                                      arrow
                                      placement="top"
                                      title="Remove"
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          const updatedPlaceholdersArr = [
                                            ...Object.keys(ps?.placeHolders),
                                          ];
                                          const updatedPromptSections = [
                                            ...promptSections,
                                          ];
                                          setPromptSections((prev) => {
                                            const map = {};
                                            updatedPlaceholdersArr
                                              .filter((ups) => ups !== ph)
                                              .map((uph) => (map[uph] = ''));
                                            // console.log(map);
                                            return updatedPromptSections?.map(
                                              (ups) => {
                                                if (ups.type === ps.type) {
                                                  return {
                                                    ...ups,
                                                    placeHolders: map,
                                                  };
                                                } else {
                                                  return ups;
                                                }
                                              },
                                            );
                                          });
                                        }}
                                      >
                                        <Delete sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                ),
                              )}
                            </Box>
                          ) : null}
                          <Box
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'space-between'}
                            sx={{
                              background: '#f1f1f1',
                              padding: '8px 16px',
                            }}
                          >
                            <Typography color={'text.secondary'}>
                              {ps?.type}
                            </Typography>
                            <FormControl>
                              <Select
                                size="small"
                                labelId="country-select-label"
                                id="country-select"
                                name="country"
                                MenuProps={{ disableScrollLock: true }}
                                onChange={(e) => {
                                  const updatedPromptSections = promptSections?.map(
                                    (ups) => {
                                      if (ups?.type === ps?.type) {
                                        return {
                                          ...ups,
                                          optionalSection: e.target.value,
                                        };
                                      } else return ups;
                                    },
                                  );
                                  setPromptSections(updatedPromptSections);
                                }}
                                value={ps?.optionalSection}
                              >
                                <MenuItem value={true}>Optional</MenuItem>
                                <MenuItem value={false}>Mandatory</MenuItem>
                              </Select>
                            </FormControl>
                            <Button
                              variant="text"
                              onClick={() => {
                                setPromptSections((prev) =>
                                  prev.filter(
                                    (prevps) => prevps?.type !== ps?.type,
                                  ),
                                );
                              }}
                            >
                              Remove
                            </Button>
                          </Box>
                          <Box
                            display={'flex'}
                            flexDirection={'column'}
                            gap={1}
                          >
                            <Typography
                              variant="body2"
                              color={'text.secondary'}
                            >
                              Section Prompt
                            </Typography>
                            <TextField
                              autoFocus
                              placeholder="Section Prompt"
                              variant="outlined"
                              color="primary"
                              size="small"
                              multiline
                              rows={7}
                              name="sectionPrompt"
                              value={ps?.text}
                              onChange={(e) => {
                                const updatedPromptSections = promptSections?.map(
                                  (ups) => {
                                    if (ups?.type === ps?.type) {
                                      return {
                                        ...ups,
                                        text: e.target.value,
                                      };
                                    } else return ups;
                                  },
                                );
                                setPromptSections(updatedPromptSections);
                              }}
                              fullWidth
                            />
                            {promptType === 'io_bond_call_summary' &&
                            ps?.type === 'sales_call_summary' ? (
                              <Box
                                display={'flex'}
                                flexDirection={'column'}
                                gap={1}
                              >
                                <Box
                                  display={'flex'}
                                  alignItems={'center'}
                                  justifyContent={'space-between'}
                                >
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => {
                                      setGettingJSONProperties(true);
                                      dispatch(
                                        getJSONProperties(
                                          ps,
                                          (data) => {
                                            setGettingJSONProperties(false);
                                            console.log(data);
                                            setJsonProperties(
                                              data?.propertyConfigs?.map(
                                                (pc) => {
                                                  return {
                                                    ...pc,
                                                    title: pc?.propertyName
                                                      ?.split('_')
                                                      ?.map((w) =>
                                                        capitalizeText(w),
                                                      )
                                                      ?.join(' '),
                                                  };
                                                },
                                              ),
                                            );
                                          },
                                          () => {
                                            setGettingJSONProperties(false);
                                          },
                                        ),
                                      );
                                    }}
                                    disabled={gettingJSONProperties}
                                    startIcon={
                                      gettingJSONProperties ? (
                                        <CircularProgress size={20} />
                                      ) : null
                                    }
                                  >
                                    Get JSON Properties
                                  </Button>
                                </Box>
                                <Box display={'flex'} flexDirection={'column'}>
                                  <Typography
                                    variant="caption"
                                    color={'text.secondary'}
                                    fontWeight={'bold'}
                                  >
                                    Extracted JSON Properties
                                  </Typography>
                                  <Box
                                    display={'flex'}
                                    flexDirection={'column'}
                                    gap={1}
                                  >
                                    <Grid container spacing={2}>
                                      <Grid item xs={2}>
                                        <Typography>Property</Typography>
                                      </Grid>
                                      <Grid item xs={2}>
                                        <Typography>Title</Typography>
                                      </Grid>
                                      <Grid item xs={2}>
                                        <Typography>Type</Typography>
                                      </Grid>
                                      <Grid item xs={3}>
                                        <Typography>Fallback Text</Typography>
                                      </Grid>
                                      <Grid item xs={3}>
                                        <Typography>Icon Path</Typography>
                                      </Grid>
                                    </Grid>
                                    {jsonProperties.map((jsonProp) => (
                                      <Grid container spacing={2}>
                                        <Grid item xs={2}>
                                          <Chip
                                            label={jsonProp?.propertyName}
                                            color="primary"
                                          />
                                        </Grid>
                                        <Grid item xs={2}>
                                          <TextField
                                            placeholder="Property Title"
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            name="propertyTitle"
                                            value={jsonProp?.title || ''}
                                            onChange={(e) => {
                                              const updatedJsonProperties = jsonProperties?.map(
                                                (jp) => {
                                                  if (
                                                    jp?.propertyName ===
                                                    jsonProp?.propertyName
                                                  ) {
                                                    return {
                                                      ...jp,
                                                      title: e.target.value,
                                                    };
                                                  } else return jp;
                                                },
                                              );
                                              setJsonProperties(
                                                updatedJsonProperties,
                                              );
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={2}>
                                          <FormControl
                                            variant="outlined"
                                            size="small"
                                          >
                                            <Select
                                              // ref={promptSelectRef}
                                              labelId="property-type-select-label"
                                              // label="Select Prompt"
                                              value={jsonProp?.type || ''}
                                              onChange={(e) => {
                                                const updatedJsonProperties = jsonProperties?.map(
                                                  (jp) => {
                                                    if (
                                                      jp?.propertyName ===
                                                      jsonProp?.propertyName
                                                    ) {
                                                      return {
                                                        ...jp,
                                                        type: e.target.value,
                                                      };
                                                    } else return jp;
                                                  },
                                                );
                                                setJsonProperties(
                                                  updatedJsonProperties,
                                                );
                                              }}
                                            >
                                              <MenuItem value={'list<string>'}>
                                                List of Strings
                                              </MenuItem>
                                              <MenuItem value={'list<map>'}>
                                                List of Objects
                                              </MenuItem>
                                              <MenuItem value={'string'}>
                                                String
                                              </MenuItem>
                                              <MenuItem value={'map'}>
                                                Object
                                              </MenuItem>
                                              <MenuItem value={'number'}>
                                                Number
                                              </MenuItem>
                                            </Select>
                                          </FormControl>
                                        </Grid>
                                        <Grid item xs={3}>
                                          <TextField
                                            autoFocus
                                            placeholder="Fallback Text"
                                            variant="outlined"
                                            color="primary"
                                            multiline
                                            rows={3}
                                            size="small"
                                            name="fallbackText"
                                            value={jsonProp?.fallbackText || ''}
                                            onChange={(e) => {
                                              const updatedJsonProperties = jsonProperties?.map(
                                                (jp) => {
                                                  if (
                                                    jp?.propertyName ===
                                                    jsonProp?.propertyName
                                                  ) {
                                                    return {
                                                      ...jp,
                                                      fallbackText:
                                                        e.target.value,
                                                    };
                                                  } else return jp;
                                                },
                                              );
                                              setJsonProperties(
                                                updatedJsonProperties,
                                              );
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={3}>
                                          <TextField
                                            autoFocus
                                            placeholder="Icon Path"
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            name="icon"
                                            value={jsonProp?.icon || ''}
                                            onChange={(e) => {
                                              const updatedJsonProperties = jsonProperties?.map(
                                                (jp) => {
                                                  if (
                                                    jp?.propertyName ===
                                                    jsonProp?.propertyName
                                                  ) {
                                                    return {
                                                      ...jp,
                                                      icon: e.target.value,
                                                    };
                                                  } else return jp;
                                                },
                                              );
                                              setJsonProperties(
                                                updatedJsonProperties,
                                              );
                                            }}
                                          />
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </Box>
                                </Box>
                              </Box>
                            ) : null}
                            <Typography
                              variant="body2"
                              color={'text.secondary'}
                            >
                              Section Default Prompt (will be used in case any
                              of the placeholder value is not coming in request)
                            </Typography>
                            <TextField
                              autoFocus
                              placeholder="Section Default Prompt"
                              variant="outlined"
                              color="primary"
                              size="small"
                              multiline
                              rows={4}
                              sx={{ mt: 1 }}
                              name="sectionDefaultPrompt"
                              value={ps?.defaultText || ''}
                              onChange={(e) => {
                                const updatedPromptSections = promptSections?.map(
                                  (ups) => {
                                    if (ups?.type === ps?.type) {
                                      return {
                                        ...ups,
                                        defaultText: e.target.value,
                                      };
                                    } else return ups;
                                  },
                                );
                                setPromptSections(updatedPromptSections);
                              }}
                              fullWidth
                            />
                          </Box>
                        </Box>
                      </Grid>
                    </>
                  ))}
                  <Grid item xs={12}>
                    <Box
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'flex-end'}
                      gap={1}
                    >
                      {selectedPrompt !== 'create' ? (
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            if (promptType === 'conversation') {
                              setShowConfirmPromptUpdateDialog(selectedPrompt);
                            } else {
                              dispatch(
                                updatePrompt(
                                  selectedPrompt,
                                  {
                                    description: '',
                                    promptSections: promptSections,
                                    title: promptTitle,
                                    responseType,
                                    useWebSearch: useWebSearch === 'true',
                                    promptType: promptType,
                                    jsonConfig:
                                      promptType === 'io_bond_call_summary'
                                        ? {
                                            propertyConfigs: jsonProperties,
                                          }
                                        : null,
                                    model: model,
                                  },
                                  (data) => {
                                    setSelectedPrompt('');
                                    console.log('update respones', data);
                                    setShowConfirmPromptUpdateDialog(null);
                                  },
                                ),
                              );
                            }
                          }}
                        >
                          Update Prompt
                        </Button>
                      ) : null}
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => {
                          dispatch(
                            createNewPrompt(
                              {
                                description: '',
                                promptSections: promptSections,
                                title: promptTitle,
                                promptType: promptType,
                                responseType,
                                useWebSearch: useWebSearch === 'true',
                                jsonConfig:
                                  promptType === 'io_bond_call_summary'
                                    ? {
                                        propertyConfigs: jsonProperties,
                                      }
                                    : null,
                                model: model,
                              },
                              (data) => {
                                dispatch(
                                  getAllPrompts(promptType, 15, null, () => {
                                    console.log('create prompt respones', data);
                                    setSelectedPrompt('');
                                  }),
                                );
                              },
                            ),
                          );
                        }}
                      >
                        Create New Prompt
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          ) : (
            <>
              <FormControl
                variant="outlined"
                size="small"
                sx={{ marginBottom: 2, width: 250 }}
              >
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Prompt Type
                </FormLabel>
                <Select
                  // ref={promptSelectRef}
                  labelId="prompt-select-label"
                  // label="Select Prompt"
                  value={promptType || ''}
                  onChange={(e) => {
                    setPromptType(e.target.value);
                  }}
                >
                  {promptTypes?.map((promptType) => (
                    <MenuItem value={promptType}>
                      {promptTypeMapping?.[promptType]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TableContainer
                component={Paper}
                sx={{
                  minHeight: 'calc(100vh - 200px)',
                  maxHeight: 'calc(100vh - 200px)',
                  overflowY: 'scroll',
                  '&::-webkit-scrollbar': {
                    width: '5px',
                  },
                  '&::-webkit-scrollbar-track': {
                    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: 2,
                  },
                }}
                onScroll={handleListScroll}
              >
                <Table
                  sx={{ minWidth: 750 }}
                  stickyHeader
                  aria-label="simple table"
                >
                  <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                    <TableRow>
                      <TableCell>
                        <Typography
                          variant={'caption'}
                          fontWeight={700}
                          sx={{ textTransform: 'uppercase' }}
                        >
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant={'caption'}
                          fontWeight={700}
                          sx={{ textTransform: 'uppercase' }}
                        >
                          TITLE
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant={'caption'}
                          fontWeight={700}
                          sx={{ textTransform: 'uppercase' }}
                        >
                          TYPE
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant={'caption'}
                          fontWeight={700}
                          sx={{ textTransform: 'uppercase' }}
                          align="center"
                        >
                          DATE
                        </Typography>
                      </TableCell>
                      {promptType !== 'conversation' ? (
                        <TableCell align="center">
                          <Typography
                            variant={'caption'}
                            fontWeight={700}
                            sx={{ textTransform: 'uppercase' }}
                            align="center"
                          >
                            Default
                          </Typography>
                        </TableCell>
                      ) : null}
                      <TableCell>
                        <Typography
                          variant={'caption'}
                          fontWeight={700}
                          sx={{ textTransform: 'uppercase' }}
                          align="center"
                        >
                          ACTIONS
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {prompts.map((prompt, i) => (
                      <TableRow
                        key={i}
                        // sx={{
                        //   '&:last-child td, &:last-child th': {
                        //     border: 0,
                        //   },
                        // }}
                      >
                        <TableCell component="th" scope="row">
                          <Typography variant={'subtitle2'} fontWeight={700}>
                            {prompt?.id}
                          </Typography>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Typography variant={'subtitle2'} fontWeight={700}>
                            {prompt?.title}
                          </Typography>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Typography variant={'subtitle2'} fontWeight={700}>
                            {capitalizeText(
                              prompt?.promptType?.split('_').join(' '),
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant={'caption'}
                            // fontWeight={700}
                            // sx={{
                            //   color: theme.palette.success.main,
                            // }}
                          >
                            {moment(prompt?.createdOn).format('DD MMMM YYYY')}
                          </Typography>
                        </TableCell>
                        {promptType !== 'conversation' ? (
                          <TableCell align="center">
                            <Tooltip
                              arrow
                              placement="top"
                              title={'Make this prompt default prompt'}
                            >
                              {prompt?.customFields?.selected ? (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled
                                  onClick={() => {}}
                                >
                                  Default
                                </Button>
                              ) : (
                                <Button
                                  variant="text"
                                  color="primary"
                                  onClick={(e) => {
                                    dispatch(
                                      makePromptAsDefaultPrompt(
                                        prompt?.id,
                                        promptType,
                                        () => {
                                          alert('Default Prompt updated');
                                          dispatch(
                                            getAllPrompts(
                                              promptType,
                                              15,
                                              null,
                                              () => {},
                                            ),
                                          );
                                        },
                                      ),
                                    );
                                  }}
                                >
                                  Make it Default
                                </Button>
                              )}
                            </Tooltip>
                          </TableCell>
                        ) : null}
                        <TableCell>
                          <Box display={'flex'} alignItems={'center'} gap={1}>
                            <Tooltip
                              title={'Preview Prompt'}
                              placement="top"
                              arrow
                            >
                              <IconButton
                                onClick={() => {
                                  dispatch(
                                    getPromptPreview(
                                      {
                                        description: prompt?.description,
                                        promptSections: prompt?.promptSections,
                                        promptType: prompt?.promptType,
                                        title: prompt?.title,
                                      },
                                      (promptPreview) => {
                                        console.log(promptPreview);
                                        setShowPromptPreviewFor(prompt?.title);
                                        setShowPromptPreview(promptPreview);
                                      },
                                    ),
                                  );
                                }}
                              >
                                <Assignment color="default" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={'Edit'} placement="top" arrow>
                              <IconButton
                                onClick={() => {
                                  setSelectedPrompt(prompt?.id);
                                }}
                              >
                                <Edit
                                  color={
                                    prompt.transcript ? 'primary' : 'default'
                                  }
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={'Delete'} placement="top" arrow>
                              <IconButton
                                onClick={() => {
                                  setShowConfirmDeleteDialog(prompt?.id);
                                }}
                              >
                                <Delete color={'default'} />
                              </IconButton>
                              {/* )} */}
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TableCell
                        variant="footer"
                        colSpan={6}
                        sx={{
                          padding: 0,
                        }}
                      >
                        {fetchingPagination ? (
                          <Box
                            sx={{
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'center',
                              padding: 1,
                              textAlign: 'center',
                            }}
                          >
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={handleListScroll}
                              disabled
                            >
                              <Typography color="textPrimary">
                                Loading more prompts ...{' '}
                              </Typography>
                              <CircularProgress size={20} />
                            </Button>
                          </Box>
                        ) : emptyList === false && prompts.length >= 10 ? (
                          <Box
                            sx={{
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'center',
                              padding: 1,
                              textAlign: 'center',
                            }}
                          >
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                              onClick={(e) => handleListScroll(e, true)}
                            >
                              Load More
                            </Button>
                          </Box>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </>
          )}
          {!selectedPrompt ? (
            <Tooltip arrow placement="top" title="Create New">
              <Fab
                size="small"
                color="primary"
                aria-label="add"
                sx={{ position: 'absolute', bottom: 30, right: 30 }}
                onClick={() => setSelectedPrompt('create')}
              >
                <Add />
              </Fab>
            </Tooltip>
          ) : null}
        </Box>
      </Box>
      <Drawer
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={Boolean(showPromptPreview)}
        anchor="right"
        onClose={(e, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            // boxShadow: theme.shadows[5],
            outline: 'none',
            maxHeight: '100vh',
            maxWidth: '40vw',
            minWidth: '40vw',
            overflowY: 'auto',
            borderRadius: 1,
            position: 'relative',
          }}
        >
          <Box
            p={1}
            sx={{
              borderBottom: '1px solid #d3d3d3',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={() => {
                setShowPromptPreview('');
              }}
            >
              <ChevronRight sx={{}} />
            </IconButton>
            <Typography color={'text.secondary'}>
              {showPromptPreviewFor}(Prompt Preview)
            </Typography>
          </Box>
          <Box
            // ref={drawerContentRef}
            sx={{
              minHeight: 'calc(100vh - 80px)',
              maxHeight: 'calc(100vh - 80px)',
              overflowY: 'scroll',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
              },
              padding: 2,
            }}
          >
            <Typography sx={{ whiteSpace: 'pre-wrap' }}>
              {showPromptPreview}
            </Typography>
          </Box>
        </Box>
      </Drawer>
      <Dialog
        open={Boolean(showConfirmDeleteDialog)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <Box display={'flex'} flexDirection={'column'} gap={2}>
            <DialogContentText id="alert-dialog-description" flex={1}>
              {botsByPromptId &&
              botsByPromptId?.length > 0 &&
              promptType === 'conversation'
                ? 'Following bots are using this prompt. Are you sure you want to delete this prompt?'
                : 'Are you sure you want to delete this prompt?'}
            </DialogContentText>
            {botsByPromptId &&
            botsByPromptId?.length > 0 &&
            promptType === 'conversation' ? (
              <Box gap={1} display={'flex'} flexDirection={'column'}>
                {botsByPromptId?.map((bot) => {
                  return (
                    <Box
                      key={bot?.id}
                      flex={1}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 1,
                        border: '1px solid #d3d3d3',
                        borderRadius: 1,
                      }}
                    >
                      <Typography variant="body1" color={'primary.main'}>
                        {bot?.title}
                      </Typography>
                      {bot?.description ? (
                        <Typography
                          variant="subtitle2"
                          color={'text.secondary'}
                        >
                          {bot?.description}
                        </Typography>
                      ) : null}
                    </Box>
                  );
                })}
              </Box>
            ) : null}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              setShowConfirmDeleteDialog(null);
            }}
            color="primary"
            // autoFocus
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={(e) => {
              dispatch(
                deletePrompt(showConfirmDeleteDialog, () => {
                  dispatch({
                    type: 'UPDATE_PROMPTS_AFTER_DELETE',
                    payload: {
                      id: showConfirmDeleteDialog,
                    },
                  });
                  setShowConfirmDeleteDialog(null);
                }),
              );
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(showConfirmPromptUpdateDialog)}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <Box display={'flex'} flexDirection={'column'} gap={2}>
            <DialogContentText id="alert-dialog-description" flex={1}>
              {botsByPromptId && botsByPromptId?.length > 0
                ? 'Following bots are using this prompt. Updating this prompt will also update these bots.'
                : 'Are you sure you want to update this prompt?'}
            </DialogContentText>
            {botsByPromptId && botsByPromptId?.length > 0 ? (
              <Box gap={1} display={'flex'} flexDirection={'column'}>
                {botsByPromptId?.map((bot) => {
                  return (
                    <Box
                      key={bot?.id}
                      flex={1}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 1,
                        border: '1px solid #d3d3d3',
                        borderRadius: 1,
                      }}
                    >
                      <Typography variant="body1" color={'primary.main'}>
                        {bot?.title}
                      </Typography>
                      {bot?.description ? (
                        <Typography
                          variant="subtitle2"
                          color={'text.secondary'}
                        >
                          {bot?.description}
                        </Typography>
                      ) : null}
                    </Box>
                  );
                })}
              </Box>
            ) : null}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              setShowConfirmPromptUpdateDialog(null);
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={(e) => {
              if (botsByPromptId && botsByPromptId?.length > 0) {
                dispatch(
                  updateBotsPrompt(
                    {
                      bots: botsByPromptId?.map((bot) => {
                        return bot?.id;
                      }),
                      promptId: showConfirmPromptUpdateDialog,
                      promptSections: promptSections,
                    },
                    () => {
                      dispatch(
                        updatePrompt(
                          selectedPrompt,
                          {
                            description: '',
                            promptSections: promptSections,
                            title: promptTitle,
                            responseType,
                            promptType: promptType,
                            model: model,
                            useWebSearch: useWebSearch === 'true',
                          },
                          (data) => {
                            setSelectedPrompt('');
                            console.log('update respones', data);
                            setShowConfirmPromptUpdateDialog(null);
                          },
                        ),
                      );
                    },
                  ),
                );
              } else {
                dispatch(
                  updatePrompt(
                    selectedPrompt,
                    {
                      description: '',
                      promptSections: promptSections,
                      title: promptTitle,
                      responseType,
                      promptType: promptType,
                      model: model,
                      useWebSearch: useWebSearch === 'true',
                    },
                    (data) => {
                      setSelectedPrompt('');
                      console.log('update respones', data);
                      setShowConfirmPromptUpdateDialog(null);
                    },
                  ),
                );
              }
            }}
            color="primary"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Dialog
        open={showPermissionDeniedError}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          zIndex: 10002,
          '& .MuiPaper-root-MuiDialog-paper': {
            maxWidth: '70vw',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          Camera and microphone are blocked
        </DialogTitle>
        <DialogContent>
          <Box display={'flex'} alignItems={'center'} gap={2}>
            <Box flex={1}>
              <img src="/camerahelp.png" width={'100%'} height={'100%'} />
            </Box>
            <DialogContentText id="alert-dialog-description" flex={1}>
              To record your video we need permission to use your camera and
              microphone. Click the <Lock /> Lock Icon (usually in your
              browser&apos;s address bar) to allow permissions and start
              recording.
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            // data-trackid={'cta_permission_denied_dialog_close'}
            onClick={(e) => {
              // handleTrackEvent(e, `cta_permission_denied_dialog_close`);
              setShowPermissionDeniedError(false);
              // if (testMode) setShowTestDeviceDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Dismiss
          </Button>
        </DialogActions>
      </Dialog> */}
    </Fixed>
  );
};

export default Prompts;
